export default __webpack_public_path__ + "assets/malta-flag.png";